var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import LastPageIcon from '@material-ui/icons/LastPage';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTablePagination from '@material-ui/core/TablePagination';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            flexShrink: 0,
            marginLeft: theme.spacing(2.5),
        },
        toolbar: {
            paddingLeft: '5px',
        },
        spacer: {
            display: 'none',
        },
    });
});
var StyledTablePagination = styled(MuiTablePagination)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  p:nth-child(4) {\n    flex: 1 0 auto;\n    text-align: right;\n  }\n"], ["\n  p:nth-child(4) {\n    flex: 1 0 auto;\n    text-align: right;\n  }\n"])));
var StyledIconButton = styled(IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", " !important;\n  padding: 2px !important;\n"], ["\n  color: ", " !important;\n  padding: 2px !important;\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '#9e9e9e' : '#000000');
});
var TablePaginationActions = function (props) {
    var classes = useStyles({});
    var theme = useTheme();
    var count = props.count, page = props.page, rowsPerPage = props.rowsPerPage, onChangePage = props.onChangePage;
    var handleFirstPageButtonClick = function (event) {
        onChangePage(event, 0);
    };
    var handleBackButtonClick = function (event) {
        onChangePage(event, page - 1);
    };
    var handleNextButtonClick = function (event) {
        onChangePage(event, page + 1);
    };
    var handleLastPageButtonClick = function (event) {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(StyledIconButton, { onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": 'first page' }, theme.direction === 'rtl' ? React.createElement(LastPageIcon, null) : React.createElement(FirstPageIcon, null)),
        React.createElement(StyledIconButton, { onClick: handleBackButtonClick, disabled: page === 0, "aria-label": 'previous page' }, theme.direction === 'rtl' ? React.createElement(KeyboardArrowRight, null) : React.createElement(KeyboardArrowLeft, null)),
        React.createElement(StyledIconButton, { onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": 'next page' }, theme.direction === 'rtl' ? React.createElement(KeyboardArrowLeft, null) : React.createElement(KeyboardArrowRight, null)),
        React.createElement(StyledIconButton, { onClick: handleLastPageButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": 'last page' }, theme.direction === 'rtl' ? React.createElement(FirstPageIcon, null) : React.createElement(LastPageIcon, null))));
};
export default function TablePagination(props) {
    var classes = useStyles({});
    var rowsPerPageOptions = props.rowsPerPageOptions, colSpan = props.colSpan, rowsCount = props.rowsCount, handleChangePage = props.handleChangePage, handleChangeRowsPerPage = props.handleChangeRowsPerPage, page = props.page, rowsPerPage = props.rowsPerPage;
    var onChangePage = function (event, newPage) {
        handleChangePage(newPage);
    };
    var onChangeRowsPerPage = function (event) {
        handleChangeRowsPerPage(event.target.value);
    };
    return (React.createElement(MuiTableRow, null,
        React.createElement(StyledTablePagination, { onPageChange: function () { }, classes: {
                toolbar: classes.toolbar,
                spacer: classes.spacer,
            }, rowsPerPageOptions: rowsPerPageOptions, colSpan: colSpan, count: rowsCount, rowsPerPage: rowsPerPage, page: page, SelectProps: {
                native: true,
            }, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, ActionsComponent: TablePaginationActions })));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=TablePagination.js.map